export default __webpack_public_path__ + "static/kurorty-img-3-d78b54e80f465e2923ac2816cdfc76f9.png";